import coursebg1 from '../assets/images/workshop2026/fusion360.jpg'
import coursebg2 from '../assets/images/workshop2026/matlab.jpg'
import coursebg3 from '../assets/images/workshop2026/solarDesign.jpg'
import coursebg4 from '../assets/images/workshop2026/dftModelling.jpg'
import coursebg5 from '../assets/images/workshop2026/abaqus.jpg'
import coursebg6 from '../assets/images/workshop2026/comsolmultiphysics.jpg'
import coursebg7 from '../assets/images/workshop2026/phaseField.jpg'

export const jun2026details = {
    courses : [
    {
      id: 1,
      title: '3D Design & Printing',
      desc: 'CAD fundamental and hands-on 3D printing workflows for engineering prototypes.',
      tag: 'Day 1',
      bg: coursebg1,
      emoji: '🖨️',
    },
    {
      id: 2,
      title: 'MATLAB',
      desc: 'Introduction to data analysis using MATLAB for materials research.',
      tag: 'Day 1',
      bg: coursebg2,
      emoji: '📊',
    },
    {
      id: 3,
      title: 'Solar Power Design',
      desc: 'Design, simulate, and evaluate solar energy systems with hands-on testing methodologies.',
      tag: 'Day 2-3',
      mandatory: false,
      bg: coursebg3,
      emoji: '☀️',
    },
    {
      id: 4,
      title: 'DFT Modelling',
      desc: 'Density Functional Theory for predicting electronic structure and material properties from first principles.',
      tag: 'Day 2-3',
      mandatory: false,
      bg: coursebg4,
      emoji: '⚛️',
    },
    {
      id: 5,
      title: 'ABAQUS Modelling',
      desc: 'Finite element analysis and structural simulation using ABAQUS for advanced materials and engineering problems.',
      tag: 'Day 2-3',
      mandatory: false,
      bg: coursebg5,
      emoji: '🔩',
    },
    {
      id: 6,
      title: 'COMSOL Multiphysics',
      desc: 'Multi-physics simulation of heat transfer, fluid dynamics, and electromagnetics using COMSOL.',
      tag: 'Day 2-3',
      mandatory: false,
      bg: coursebg6,
      emoji: '🌊',
    },
    {
      id: 7,
      title: 'Phase-Field Modelling',
      desc: 'Simulation of microstructure evolution, solidification, and phase transformations in materials systems.',
      tag: 'Day 2-3',
      mandatory: false,
      bg: coursebg7,
      emoji: '🧪',
    },
],

  outcome : [
        { 
            title : "Computational Modelling & Simulation for Materials Engineering",
            text : "Develop practical competence in computational modelling and simulation for materials engineering applications. Participants will learn how to formulate problems, build models, and interpret simulation results using tools such as MATLAB, ABAQUS, COMSOL Multiphysics, and Phase Field modelling approaches."
        },
        { 
            title : "Design, Simulation, and Optimization of Engineering Systems",
            text : "Apply simulation-driven design methods to real-world engineering problems, including solar energy systems and material performance optimization. Participants will learn how to design, test, and refine systems virtually before physical implementation."
        },
        { 
            title : "3D Design, Prototyping, and Digital Fabrication",
            text : "Gain hands-on experience in 3D design and additive manufacturing workflows, including modelling, slicing, and prototyping. Participants will understand how to translate digital designs into physical components for engineering applications."
        },
        { 
            title : "Advanced Materials Modelling (DFT & Phase Field Methods)",
            text : "Understand the fundamentals of Density Functional Theory (DFT) and Phase Field modelling in predicting material behaviour at atomic and microstructural scales. Participants will explore how these methods are used in modern materials research and innovation."
        },
        { 
            title : "Industry-Relevant Skills for Research and Engineering Practice",
            text : "Build industry-relevant computational and analytical skills that are directly applicable in research, academia, and engineering practice, enabling participants to solve complex problems while reducing reliance on costly experimental trial-and-error."
        }
    ]
}
export const dec2026details = {
  outcome : [
        { 
            title: "Computational Modelling, Simulation, and Machine Learning",

            text: "Develop practical competence in computational modelling and simulation for engineering and materials applications. Participants will use MATLAB to formulate problems, perform simulations, analyse data, and apply machine learning techniques to engineering problems."
        },

        { 
            title: "Engineering Design, Simulation, and Testing",

            text: "Apply computational tools to design, simulate, and evaluate engineering systems. Participants will develop practical skills in solar power system design and testing, as well as using simulation to assess and optimize engineering performance."
        },

        { 
            title: "Materials Modelling at the Atomic Scale",

            text: "Understand the fundamentals of Density Functional Theory (DFT) and its application to materials research. Participants will learn how computational methods can be used to investigate material properties and predict behaviour at the atomic scale."
        },

        { 
            title: "Finite Element Analysis for Engineering Applications",

            text: "Develop practical skills in finite element modelling and analysis using ABAQUS CAE and COMSOL Multiphysics. Participants will learn to construct models, define material and loading conditions, run simulations, and interpret results for engineering applications."
        },

        { 
            title: "Industry-Relevant Computational Engineering Skills",

            text: "Build practical computational and analytical skills applicable to research, academia, and engineering practice. Participants will gain experience using MATLAB, machine learning, DFT, ABAQUS, COMSOL Multiphysics, and solar power design tools to solve real-world engineering problems."
        }
    ],
    courses : [
  {
    id: 1,
    title: 'MATLAB & ML Simulations',
    desc: 'Introduction to data analysis using MATLAB for materials research.',
    tag: 'Day 1-2',
    bg: coursebg2,
    emoji: '📊',
  },
  {
    id: 2,
    title: 'Solar Power Design',
    desc: 'Design, simulate, and evaluate solar energy systems with hands-on testing methodologies.',
    tag: 'Day 3',
    mandatory: false,
    bg: coursebg3,
    emoji: '☀️',
  },
  {
    id: 3,
    title: 'DFT Modelling',
    desc: 'Density Functional Theory for predicting electronic structure and material properties from first principles.',
    tag: 'Day 3',
    mandatory: false,
    bg: coursebg4,
    emoji: '⚛️',
  },
  {
    id: 4,
    title: 'ABAQUS Modelling',
    desc: 'Finite element analysis and structural simulation using ABAQUS for advanced materials and engineering problems.',
    tag: 'Day 3',
    mandatory: false,
    bg: coursebg5,
    emoji: '🔩',
  },
  {
    id: 5,
    title: 'COMSOL Multiphysics',
    desc: 'Multi-physics simulation of heat transfer, fluid dynamics, and electromagnetics using COMSOL.',
    tag: 'Day 3',
    mandatory: false,
    bg: coursebg6,
    emoji: '🌊',
  }
]};